import axios from '@/api/config';

const fodder = {
}
export default fodder;



// WEBPACK FOOTER //
// ./src/api/fodder.js